import { useEffect, useState } from "react";
import { bonusService } from "../services/api";
import { useAuth } from "../context/authContext";

/**
 * Reglas vigentes del bono de bienvenida (GET /bonuses/welcome/, público).
 * Con sesión, `eligible` indica si el usuario aún no hace su primera recarga.
 * @returns {{ welcome: object|null, loading: boolean }}
 */
export default function useWelcomeBonus() {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const [welcome, setWelcome] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return undefined;
    let cancelled = false;
    setLoading(true);
    bonusService.welcome().then((res) => {
      if (cancelled) return;
      setWelcome(res.ok ? res.data : null);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, authLoading]);

  return { welcome, loading };
}

const money = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(n);
};

/**
 * "Recarga desde $10.000 y te regalamos una fracción; desde $30.000, un billete completo."
 * Devuelve "" si el programa no está activo o no tiene montos.
 */
export function welcomeBonusText(welcome) {
  if (!welcome || welcome.active !== true) return "";
  const fraction = money(welcome.fraction_min_amount);
  const ticket = money(welcome.ticket_min_amount);
  if (fraction && ticket) {
    return `Recarga desde ${fraction} y te regalamos una fracción; desde ${ticket}, un billete completo.`;
  }
  if (fraction) return `Recarga desde ${fraction} y te regalamos una fracción.`;
  if (ticket) return `Recarga desde ${ticket} y te regalamos un billete completo.`;
  return "";
}
